module.exports = __webpack_public_path__ + "img/CutLaptop@2x.7ac5e12c.png";